// Vietnamese.
export default {
  // Brand / shell
  app_subtitle: 'Bảng KPI 2026',

  // PIN gate
  pin_subtitle: 'bảng kpi 2026',
  pin_wrong: 'PIN không đúng',
  pin_enter: 'nhập mã PIN',
  cancel: 'huỷ',

  // Role selector
  who_are_you: 'bạn là ai?',
  rs_car: 'bu car',
  rs_hj: 'bu heli-jet',
  rs_mkt: 'team marketing',
  rs_coo: 'xem quản lý · tất cả vai trò (coo / manager)',

  // Header
  hdr_import: 'nhập actuals',
  hdr_team: 'xem theo team',
  hdr_switch: 'đổi vai trò',
  hdr_docs: 'tài liệu',

  // Tabs
  tab_summary: 'summary',
  tab_weekly: 'tổng quan',
  tab_monthly: 'theo tháng',
  tab_quarterly: 'theo quý',
  tab_ytd: 'luỹ kế năm',
  tab_bonus: 'thưởng',
  tab_kpi_report: 'báo cáo kpi',
  tab_marketing: 'marketing',

  // Specialist period bar
  edit_actuals_hint: 'chỉnh actuals bên dưới → thưởng cập nhật ngay',

  // Sync indicator
  sync_loading: 'đang đồng bộ…',
  sync_ok: '✓ đã đồng bộ',
  sync_offline: '⚠ ngoại tuyến — dùng cache',
  sync_toast_offline: '⚠ không kết nối được Google Sheets — đang dùng dữ liệu cache / mock',
  retry: 'thử lại',

  // Bonus levels
  bonus_fail: 'không đạt',
  bonus_dat: 'đạt',
  bonus_xs: 'xuất sắc',
  bonus_vxs: 'vượt xuất sắc',
  bonus_fail_hint: '< 80% — không thưởng',
  bonus_dat_hint: '80–99% — ×điểm',
  bonus_xs_hint: '100–120% — ×1.2',
  bonus_vxs_hint: '> 120% — ×1.5',

  // Config modal
  config_title: 'cấu hình dashboard',
  config_intro: 'Xem kết hợp: manager thấy bảng manager, specialist thấy KPI cá nhân.',
  pin_mgmt: 'quản lý pin team',
  pin_save: 'lưu pin',
  pin_reset: 'đặt lại mặc định',
  email_mgmt: 'email team',
  email_save: 'lưu email',
  h2_fc_title: 'mục tiêu forecast h2 (USD)',
  h2_fc_hint: 'chỉnh gmv mục tiêu hàng tháng cho jun–dec 2026',
  h2_fc_save: 'lưu forecast',
  h2_fc_reset: 'đặt lại mặc định',

  // Import modal
  import_title: 'Nhập Actuals',
  import_subtitle: 'Upload CSV hoặc Excel để cập nhật KPI actuals',
  import_download_template: 'Tải Template CSV',
  import_format_hint: 'Format: role_key, kpi_index, month (1-12), value — hoặc GMV: bu, month, actual_gmv',
  import_dropzone: 'Kéo thả file vào đây hoặc click để chọn',
  import_dropzone_hint: '.csv · .xlsx · .xls',
  import_preview: 'Preview dữ liệu',
  import_choose_other: '← Chọn file khác',
  import_apply: '✓ Apply Actuals',
  import_huy: 'Huỷ',
  import_skipped: 'dòng bị bỏ qua',

  // Email modal
  email_modal_title: 'gửi kết quả kpi hàng tháng',
  email_modal_hint: 'preview email theo vai trò — click send để mở mail client',
  email_no_set: 'chưa có email',
  email_send: '✉ gửi',
};
